<template>
  <div class="modal-dim on">
    <div class="modal-wrap">
      <div class="modal-inner center">
        <div class="rd-modal">
          <!-- 헤더: 제목 + 닫기 -->
          <div class="rd-head">
            <h2 class="rd-title">등록 완료</h2>
            <button type="button" class="rd-close" @click="confirm" aria-label="닫기">
              <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 5 L15 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                <path d="M15 5 L5 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              </svg>
            </button>
          </div>

          <div class="rd-divider"></div>

          <!-- 본문 -->
          <p class="rd-body">간판 등록이 완료되었습니다.<br />사진, 소개글 등을 추가로 등록해 주세요.</p>

          <!-- 확인 -->
          <button type="button" class="rd-cta" @click="confirm">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['data']);
const emits = defineEmits(['close']);

// 등록은 이미 완료된 시점 — 확인/닫기 모두 콜백(상세 이동) 실행해 폼 잔류를 막는다.
const fnCallBack = props.data?.fnCallBack;
const confirm = () => {
  if (fnCallBack) fnCallBack();
  setTimeout(() => emits('close'), 150);
};
</script>

<style scoped lang="scss">
$g: #30CA22;

.modal-dim.on {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}
.modal-inner.center {
  width: 100%;
  max-width: 375px;
  padding: 0 16px;
}

.rd-modal {
  background: #ffffff;
  border-radius: 14px;
  padding: 30px 20px;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, sans-serif;
}

.rd-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}
.rd-title {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #000000;
  margin: 0;
}
.rd-close {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border: 0;
  background: transparent;
  color: #000000;
  cursor: pointer;
  padding: 0;
}
.rd-close svg {
  width: 20px;
  height: 20px;
}

.rd-divider {
  height: 1px;
  background: #cacaca;
  margin: 14px 0;
}

.rd-body {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.03em;
  color: #000000;
  margin: 0 0 30px;
}

.rd-cta {
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 10px;
  background: $g;
  color: #ffffff;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.3px;
  cursor: pointer;
}
.rd-cta:active {
  background: #27a91c;
}
</style>
